var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5637_4018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V26L10 22L0 26V0Z",
    fill: "#FFF3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6L11.2348 9.80041H15.2308L11.998 12.1492L13.2328 15.9496L10 13.6008L6.76718 15.9496L8.00201 12.1492L4.76919 9.80041H8.76517L10 6Z",
    fill: "#EAB222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5637_4018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.d48f191392a86efc8aed02a0dc456b05.svg";
export { ForwardRef as ReactComponent };